import React, { useState, useEffect, useMemo } from 'react';

import { useSelector, useDispatch } from 'dva';
import {
  Box,
  FormControl,
  TextField,
  IconButton,
  Select,
  MenuItem,
  useTheme,
  Button,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { Controller, useForm } from 'react-hook-form';
import DoneIcon from '@material-ui/icons/Done';
import { SMS_TYPE } from '@/constants';
import ClearIconML from '@/components/ClearIconML/index';
import MessageMLStyled from './MessageMLStyled';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import DialogDataML from '@/components/DialogDataML/DialogDataML';
import PublicModalML from '../PublicModalML/PublicModalML';
import webStorage from '@/utils/storageManager';
import { SUBACTIVITYTENANTIDSAPPIDS } from '@/constants';
import request from '@/utils/request';

const MessageML = (props) => {
  const {
    content,
    type,
    setSelectedId,
    setContent,
    icon,
    opt,
    handleSelectChange,
    info,
    disabled,
    open,
    setOpen,
  } = props;
  const theme = useTheme();
  const dispatch = useDispatch();
  const {
    control,
    setValue,
    // register,
  } = useForm({});
  const {
    smsTemplateListData,
    wechatTemplateListData,
    mmsTemplateListData,
    subTemplateListData,
    emailTemplateListData,
    lineTemplateListData,
  } = useSelector((state) => state.common);
  const TENANTID = webStorage.get('TENANT_ID');
  const [pageData, setPageData] = useState({
    pageSize: 8,
    pageNum: 1,
  });
  const [chooseTables, setChooseTables] = useState();
  const [saveChooseIds, setSaveChooseIds] = useState();
  const [templateName, setTemplateName] = useState();
  const [templateCode, setTemplateCode] = useState();
  const [templateNameSearch, setTemplateNameSearch] = useState();
  const [templateCodeSearch, setTemplateCodeSearch] = useState();
  const [clickSearch, setClickSearch] = useState(0);
  const [selectedSMSId, setSelectedSMSId] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const TEMPLATETYPE = webStorage.get('DICTOBJ')?.WECHAT_TEMP_MSG_TYPE;

  const [previewContent, setPreviewContent] = useState('');
  const [lineDetail, setLineDetail] = useState({});
  const [emailDetail, setEmailDetail] = useState({});
  const actionObj = {
    type: 'DELETE',
    dialogTitle: '删除',
    dialogContent: '确定要删除该通知配置吗？',
  };
  useEffect(() => {
    if (info && info?.[0]?.msgId) {
      setSaveChooseIds([Number(info[0].msgId)]);
      setValue('type', Number(info[0].msgId));
    } else {
      setSaveChooseIds();
      setValue('type', '');
    }
  }, [info?.length, setValue]);

  useEffect(() => {
    const appId = SUBACTIVITYTENANTIDSAPPIDS[TENANTID];
    dispatch({
      type:
        type === 1
          ? 'common/getQuerySmsTemplateList'
          : type === 2
          ? 'common/getQueryWechatTemplatePage'
          : type === 3
          ? 'common/getQueryWmpTempMsgPage'
          : type === 4
          ? 'common/getQueryMmsTemplateList'
          : type === 5
          ? 'common/getQueryEmailTemplatePage'
          : type === 6
          ? 'common/getQueryLineTempMsgPage'
          : '',
      payload: {
        values: {
          pageSize: pageData.pageSize,
          pageNum: pageData.pageNum,
          title: templateNameSearch,
          name: templateNameSearch,
          code: templateCodeSearch,
          type: selectedSMSId || null,
          approveState: type === 4 ? 'PASS' : '',
          appId: type === 3 ? appId : null,
        },
      },
      callback: () => {
        setClickSearch(clickSearch + 1);
      },
    });
  }, [
    dispatch,
    pageData.pageSize,
    pageData.pageNum,
    templateNameSearch,
    templateCodeSearch,
    selectedSMSId,
  ]);

  const columns = [
    {
      type: 'checkbox',
      width: 80,
      onChange: (a, b) => {
        setChooseTables(b);
      },
    },
    {
      title: 'ID',
      align: 'left',
      id: 'id',
      key: 'id',
      width: 306,
    },
    {
      title: type === 2 ? '模板消息名称' : '模板名称',
      id: 'title',
      width: 306,
      align: 'left',
      key: 'title',
    },
    {
      title: '类型',
      align: 'left',
      id: 'type',
      key: 'type',
      width: 306,
      render: (row) => {
        if (type === 1) {
          return SMS_TYPE?.find((item) => item.dictCode === row.type)?.nameZh;
        } else if (type === 5) {
          return TEMPLATETYPE?.find((item) => item.dictCode === row.type)
            ?.nameZh;
        } else if (type === 6) {
          return TEMPLATETYPE?.find((item) => item.dictCode === row.type)
            ?.nameZh;
        }
        return row.type;
      },
    },
  ];
  const mmsColumns = [
    {
      type: 'checkbox',
      width: 80,
      onChange: (a, b) => {
        setChooseTables(b);
      },
    },
    {
      title: 'ID',
      align: 'left',
      id: 'id',
      key: 'id',
      width: 306,
    },
    {
      title: '模板名称',
      id: 'title',
      width: 306,
      align: 'left',
      key: 'title',
    },
  ];
  const emailColumns = [
    {
      type: 'checkbox',
      width: 80,
      onChange: (a, b) => {
        setChooseTables(b);
      },
    },
    {
      title: 'ID',
      align: 'left',
      id: 'id',
      key: 'id',
      width: 306,
    },
    {
      title: '模板编号',
      id: 'code',
      width: 306,
      align: 'left',
      key: 'code',
    },
    {
      title: '模板名称',
      id: 'name',
      width: 306,
      align: 'left',
      key: 'name',
    },
  ];

  //换页
  const changePage = (obj) => {
    setPageData({ ...pageData, ...obj });
  };

  const handleChooseSuccess = () => {
    if (!chooseTables) {
      return;
    }
    const id = chooseTables.id;
    setSaveChooseIds([id]);
    setSelectedId(id);
    setContent(chooseTables?.example || chooseTables?.content);
    setValue('type', id);
    handleSelectChange(type, {
      checked: true,
      id: id,
      content: chooseTables?.example || chooseTables?.content,
    });
  };

  useEffect(() => {
    const fetchDetail = async () => {
      if (saveChooseIds?.length > 0) {
        const res = await request('/line/queryTempDetail', {
          method: 'POST',
          data: {
            id: saveChooseIds[0],
          },
        });
        setLineDetail(res.data);
      } else {
        setLineDetail({});
      }
    };
    if (type === 6) {
      fetchDetail();
    }
  }, [saveChooseIds]);
  useEffect(() => {
    const fetchDetail = async () => {
      if (saveChooseIds?.length > 0) {
        const res = await request('/message/queryMarketingTempOne', {
          method: 'POST',
          data: {
            id: saveChooseIds[0],
          },
        });
        setEmailDetail(res.data);
      } else {
        setEmailDetail({});
      }
    };
    if (type === 5) {
      fetchDetail();
    }
  }, [saveChooseIds]);
  const handleDeleteChoose = () => {
    actionObj.confirm = () => {
      setSaveChooseIds();
      setSelectedId();
      setContent();
      setValue('type', '');
      handleSelectChange(type, {
        checked: false,
        id: '',
        content: '',
      });
      setOpenDialog(false);
    };
    setCurrentAction(actionObj);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const openModal = () => {
    if (disabled || opt === 'detail') {
      return;
    }
    setOpen(true);
  };
  const typeData = type === 1 ? SMS_TYPE : TEMPLATETYPE;

  const handleClickPreview = () => {
    const htmlValue = emailTemplateListData?.data?.find(
      (i) => i.id === saveChooseIds?.[0],
    ).sendContent;
    setPreviewContent(htmlValue);
    setOpenPreviewDialog(true);
  };
  const handleClosePreviewDialog = () => {
    setOpenPreviewDialog(false);
  };
  const initButton = () => {
    const buttonNode = (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '0 16px',
          width: '100%',
          marginBottom: '24px',
          marginRight: '24px',
          marginTop: '-8px',
        }}
      >
        <Button
          sx={{ width: '100px!important' }}
          variant="contained"
          onClick={handleClosePreviewDialog}
          startIcon={<DoneIcon sx={{ width: '16px', height: '16px' }} />}
        >
          确定
        </Button>
      </Box>
    );
    return { buttonNode, isShow: true, height: 'auto' };
  };

  const sortLineDetail = useMemo(() => {
    console.log('lineDetail', lineDetail);
    if (!lineDetail || JSON.stringify(lineDetail) === '{}') {
      return [];
    }
    let arr = [];
    const customData = lineDetail.contentData.data || {};
    const sortNo = lineDetail.contentData.sortNo || {};
    Object.keys(sortNo).forEach((key) => {
      arr.push({
        name: key,
        value: customData[key],
        sortNo: sortNo[key],
      });
    });
    arr.sort((a, b) => a.sortNo - b.sortNo);
    const newCustomFields = arr.map((item) => ({
      id: item.id,
      name: item.name,
      value: item.value,
    }));
    return newCustomFields;
  }, [lineDetail]);
  return (
    <MessageMLStyled theme={theme}>
      {/* {props.children} */}
      <div className="message-title">
        <Box
          className={
            disabled || opt === 'detail'
              ? 'message-title-info message-title-info-detail'
              : 'message-title-info'
          }
        >
          {type === 1
            ? '短信通知'
            : type === 2
            ? '公众号模板消息'
            : type === 3
            ? '订阅消息'
            : type === 4
            ? '彩信通知'
            : type === 5
            ? '邮件'
            : type === 6
            ? 'LINE 模版消息'
            : ''}
        </Box>
        <div>
          {icon && (
            <span>
              <SvgIconML name={icon} size={15} />
            </span>
          )}
        </div>
      </div>
      {/* <ButtonTip title={content}> */}
      <Box
        className={
          !saveChooseIds
            ? 'message-content-wrap no-padding'
            : 'message-content-wrap'
        }
      >
        {!saveChooseIds && (
          <Box className="message-content-no" onClick={openModal}>
            <SvgIconML
              name="add"
              size={32}
              style={{ opacity: disabled || opt === 'detail' ? '0.4' : '1' }}
            />
          </Box>
        )}
        {saveChooseIds && saveChooseIds.length > 0 ? (
          <>
            {type === 5 ? (
              <div
                className={
                  disabled || opt === 'detail'
                    ? 'message-content message-content-detail'
                    : 'message-content'
                }
              >
                <div>模板编号： {emailDetail?.code}</div>
                <div>模板标题： {emailDetail?.name}</div>
                <div>
                  {type === 5 ? '邮件' : '模板'}主题： {emailDetail?.subject}
                </div>
              </div>
            ) : type === 6 ? (
              <Box
                className={
                  disabled || opt === 'detail'
                    ? 'message-content message-content-detail'
                    : 'message-content'
                }
              >
                {lineDetail?.contentData?.contentTitle && (
                  <Box className="preview-box-content-title">
                    {lineDetail?.contentData?.contentTitle}
                  </Box>
                )}
                {lineDetail?.contentData?.content
                  ?.split('\n')
                  .map((item, index) => (
                    <Box className="preview-box-content-text" key={index}>
                      {item}
                    </Box>
                  ))}
                {lineDetail?.contentData?.data && (
                  <Box className="preview-box-content-text-custom">
                    {sortLineDetail.map((item, index) => (
                      <Box key={index} display="flex" gap="0 4px">
                        <Box width="90px">
                          {item.name ? `${item.name}:` : ''}
                        </Box>
                        <Box color="#555555">{item.value}</Box>
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            ) : (
              <div
                className={
                  disabled || opt === 'detail'
                    ? 'message-content message-content-detail'
                    : 'message-content'
                }
                dangerouslySetInnerHTML={{
                  __html: content?.replaceAll('\n', '<br/>'),
                }}
              ></div>
            )}
          </>
        ) : (
          ''
        )}
        {/* </ButtonTip> */}
        {/* 选择器 */}

        {saveChooseIds && saveChooseIds.length > 0 && (
          <FormControl variant="standard" className="single-select">
            {/* <InputLabel></InputLabel> */}

            {!disabled && opt !== 'detail' && (
              <Box
                sx={{
                  display: 'flex',
                  gap: '0 21px',
                  justifyContent: 'flex-end',
                }}
              >
                {type === 5 ? (
                  <Box
                    onClick={handleClickPreview}
                    sx={{
                      color: '#1565C0 !important',
                      fontSize: '14px',
                      fontWeight: '500',
                      lineHeight: '24px',
                      cursor: 'pointer',
                    }}
                  >
                    预览
                  </Box>
                ) : (
                  ''
                )}
                <Box
                  onClick={openModal}
                  sx={{
                    color: '#1565C0 !important',
                    fontSize: '14px',
                    fontWeight: '500',
                    lineHeight: '24px',
                    cursor: 'pointer',
                  }}
                >
                  替换
                </Box>
                <Box
                  onClick={handleDeleteChoose}
                  sx={{
                    color: '#1565C0 !important',
                    fontSize: '14px',
                    fontWeight: '500',
                    lineHeight: '24px',
                    cursor: 'pointer',
                  }}
                >
                  删除
                </Box>
              </Box>
            )}
          </FormControl>
        )}
      </Box>

      <Controller
        render={() => (
          <PublicModalML
            pageData={pageData}
            changePage={changePage}
            columns={
              type === 4 || type === 3
                ? mmsColumns
                : type === 5
                ? emailColumns
                : columns
            }
            tableList={
              type === 2
                ? wechatTemplateListData.data
                : type === 1
                ? smsTemplateListData.data
                : type === 3
                ? subTemplateListData.data
                : type === 4
                ? mmsTemplateListData.data
                : type === 5
                ? emailTemplateListData.data
                : type === 6
                ? lineTemplateListData.data
                : []
            }
            singleSelect={true}
            open={open}
            setOpen={setOpen}
            pages={
              type === 2
                ? wechatTemplateListData.pages
                : type === 1
                ? smsTemplateListData.pages
                : type === 3
                ? subTemplateListData.pages
                : type === 4
                ? mmsTemplateListData.pages
                : type === 5
                ? emailTemplateListData.pages
                : type === 6
                ? lineTemplateListData.pages
                : []
            }
            total={
              type === 2
                ? wechatTemplateListData.total
                : type === 1
                ? smsTemplateListData.total
                : type === 3
                ? subTemplateListData.total
                : type === 4
                ? mmsTemplateListData.total
                : type === 5
                ? emailTemplateListData.total
                : type === 6
                ? lineTemplateListData.total
                : 0
            }
            chooseIds={saveChooseIds}
            handleChooseSuccess={handleChooseSuccess}
            clickSearch={clickSearch}
          >
            <Box className="public-search-wrap">
              <Box
                sx={{
                  color: '#212121',
                  fontSize: '18px',
                  fontWeight: '600',
                  whiteSpace: 'nowrap',
                }}
              >
                {type === 1
                  ? '选择短信通知'
                  : type === 2
                  ? '选择模板消息'
                  : type === 3
                  ? '选择订阅消息'
                  : type === 4
                  ? '选择彩信通知'
                  : type === 5
                  ? '选择邮件模板'
                  : type === 6
                  ? '选择LINE 模版消息'
                  : ''}
              </Box>
              {type === 5 ? (
                <TextField
                  className="template-name"
                  variant="standard"
                  onChange={(e) => {
                    setTemplateCode(e.target.value);
                  }}
                  onBlur={(e) => {
                    const value = e.target.value;
                    if (!value) {
                      setTemplateCodeSearch();
                      setPageData({ pageSize: 8, pageNum: 1 });
                    }
                  }}
                  value={templateCode}
                  label={''}
                  placeholder="请输入模板编号"
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        type="submit"
                        aria-label="search"
                        onClick={() => {
                          setTemplateCodeSearch(templateCode);
                          setPageData({ pageSize: 8, pageNum: 1 });
                        }}
                      >
                        <SearchIcon />
                      </IconButton>
                    ),
                  }}
                />
              ) : (
                ''
              )}
              <TextField
                className="template-name"
                variant="standard"
                onChange={(e) => {
                  setTemplateName(e.target.value);
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (!value) {
                    setTemplateNameSearch();
                    setPageData({ pageSize: 8, pageNum: 1 });
                  }
                }}
                value={templateName}
                label={''}
                placeholder={
                  type === 2 ? '请输入模板消息名称' : '请输入模板名称'
                }
                InputProps={{
                  endAdornment: (
                    <IconButton
                      type="submit"
                      aria-label="search"
                      onClick={() => {
                        setTemplateNameSearch(templateName);
                        setPageData({ pageSize: 8, pageNum: 1 });
                      }}
                    >
                      <SearchIcon />
                    </IconButton>
                  ),
                }}
              />

              {type !== 4 && type !== 5 ? (
                <FormControl
                  variant="standard"
                  fullWidth
                  className="template-sms-select"
                >
                  <Select
                    sx={{ width: '100%' }}
                    displayEmpty
                    onChange={(e) => {
                      setSelectedSMSId(e.target.value);
                    }}
                    value={selectedSMSId}
                    label=""
                    disabled={disabled || opt === 'detail'}
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <span
                            style={{
                              color: 'currentColor',
                              opacity: '0.42',
                            }}
                          >
                            {type === 1
                              ? '请选择短信类型'
                              : type === 2
                              ? '请选择模板消息类型'
                              : type === 3
                              ? '请选择订阅消息类型'
                              : type === 4
                              ? '请选择彩信类型'
                              : type === 5
                              ? '请选择邮件类型'
                              : type === 6
                              ? '请选择LINE 模版消息类型'
                              : ''}
                          </span>
                        );
                      }
                      return typeData.find((item) => item.dictCode === selected)
                        .nameZh;
                    }}
                  >
                    <MenuItem value="" disabled>
                      {type === 1
                        ? '请选择短信类型'
                        : type === 2
                        ? '请选择模板消息类型'
                        : type === 3
                        ? '请选择订阅消息类型'
                        : type === 4
                        ? '请选择彩信类型'
                        : type === 5
                        ? '请选择邮件类型'
                        : type === 6
                        ? '请选择LINE 模版消息类型'
                        : ''}
                    </MenuItem>
                    {typeData &&
                      typeData.map((item) => (
                        <MenuItem key={item.nameZh} value={item.dictCode}>
                          {item.nameZh}
                        </MenuItem>
                      ))}
                  </Select>
                  <ClearIconML
                    clearValue={selectedSMSId}
                    handleClick={() => {
                      setSelectedSMSId('');
                    }}
                  ></ClearIconML>
                </FormControl>
              ) : (
                <Box></Box>
              )}
            </Box>
          </PublicModalML>
        )}
        name="type"
        control={control}
        rules={{
          required: true,
        }}
      />
      <DialogDataML
        open={openDialog}
        title={currentAction?.dialogTitle}
        content={currentAction?.dialogContent}
        handleClose={handleCloseDialog}
        handleConfirm={currentAction?.confirm}
      ></DialogDataML>
      <DialogDataML
        open={openPreviewDialog}
        title="预览"
        content={<div dangerouslySetInnerHTML={{ __html: previewContent }} />}
        handleClose={handleClosePreviewDialog}
        button={initButton()}
      ></DialogDataML>
    </MessageMLStyled>
  );
};
export default MessageML;
